import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";

export default function ViewReturn() {
  const location = useLocation();
  const data = location.state.data;

  console.log("data", data);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  function formatDate(isoDateStr) {
    const date = new Date(isoDateStr);

    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-IN", options).replace(",", "");
  }

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Order</h2>
          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Order Id</h6>
                <p className="mt-1">{data?.returnInfo.orderId}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">User Id</h6>
                <p className="mt-1">{data?.user.email}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Requested At</h6>
                <p className="mt-1">{formatDate(data?.requestedAt)}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Approved At</h6>
                <p className="mt-1">{formatDate(data?.approvedAt)}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">User Id</h6>
                <p className="mt-1">{data?.user._id}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data?.status}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="">
                <h6 className="text-sm font-medium">Reason</h6>
                <p className="mt-1">{data.reason}</p>
              </div>
              {/* <div className="w-1/2">
                <h6 className="text-sm font-medium">Payment Method</h6>
                <p className="mt-1">{data.paymentMethod}</p>
              </div> */}
            </div>
            {/* <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Address</h6>
                <p className="mt-1">{data.address.fullAddress + " " + data.address.city + " " + data.address.state + ", " + data.address.pincode}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
            </div>

            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Total Amount</h6>
                <p className="mt-1">{data.totalAmount}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(data.createdAt)}</p>
              </div>
            </div> */}
          </div>
        </div>
      </Layout>
    </div>
  );
}
